import { Wk8ReadService } from '@core/wk8/wk8-read.service';
import { Wk8TutorService } from '@core/wk8/wk8-tutor.service';
import { ILeesVariant } from '@features/wk8/mechanics/wk8-lees/variants/lees-variant.interface';
import { Wk8LeesComponent } from '@features/wk8/mechanics/wk8-lees/wk8-lees.component';
import { waitForMillis } from '@shared/delay.utils';
import { WordToKlankConverter } from '@shared/woordkr8/WordToKlankConverter';

export class LeesZinVariant implements ILeesVariant {
  readonly #ctx: {
    wk8TutorService: Wk8TutorService;
    wk8ReadService: Wk8ReadService;
  };
  private leesMechanic!: Wk8LeesComponent;

  private sentence: string[] = [];
  private isDestroyed = false;

  public constructor(sentence: string[], ctx: { wk8TutorService: Wk8TutorService; wk8ReadService: Wk8ReadService }) {
    this.#ctx = ctx;
    this.sentence = sentence;
  }

  public async init(leesMechanic: Wk8LeesComponent): Promise<void> {
    this.leesMechanic = leesMechanic;
  }

  public async start(): Promise<void> {
    const modes = ['read-together', 'read-alone'] as const;
    for (let i = 0; i < modes.length; i++) {
      await this.#ctx.wk8TutorService.showMechanic(modes[i] === 'read-together' ? 'lees_zin_samen' : 'lees_zin_alleen');

      await this.leesMechanic.unhighlight();

      if (i === 0) {
        await Promise.all([
          this.leesMechanic.showMetronome(true), //
          this.leesMechanic.setWord(this.sentence, false),
        ]);
        await waitForMillis(200); // extra delay
      }

      while (true) {
        const timePerKlank = await this.#ctx.wk8ReadService.getReadSpeed();
        const klankenPerWord = this.sentence.map((word) => WordToKlankConverter.breakupWord(word).length);
        const klankPerWord = klankenPerWord.reduce((a, b) => a + b, 0) / klankenPerWord.length;
        const timePerWord = Math.round(timePerKlank * klankPerWord);
        await this.leesMechanic.readPass(timePerWord);
        if (this.isDestroyed) return;

        const choice = await this.#ctx.wk8TutorService.waitForChoice('herstart trager', 'verder');
        if (choice === 'verder') {
          await this.#ctx.wk8ReadService.updateReadSpeed(true);
          break;
        }

        await this.#ctx.wk8ReadService.updateReadSpeed(false);
        await this.leesMechanic.unhighlight();
      }
    }

    this.leesMechanic.finish();
  }

  public async stop(): Promise<void> {
    this.isDestroyed = true;
  }
}
